import { render, staticRenderFns } from "./ListadoCertificados.vue?vue&type=template&id=58a95b5a&"
import script from "./ListadoCertificados.vue?vue&type=script&lang=js&"
export * from "./ListadoCertificados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports